import script from "./DetailedReport.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailedReport.vue?vue&type=script&setup=true&lang=js"

import "./DetailedReport.vue?vue&type=style&index=0&id=5aef6050&lang=css"

const __exports__ = script;

export default __exports__